import * as React from 'react';
import styled from 'styled-components';
import Colors from '../lib/Colors';

function UnstyledErrorMessage(props: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={props.className}>{props.children}</div>;
}

const ErrorMessage = styled(UnstyledErrorMessage)`
  margin: 0.25rem 0;
  padding: 1rem;
  background-color: ${Colors.errorBackground};
  color: ${Colors.error};
  font-size: 1rem;
`;

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.tsx